// extracted by mini-css-extract-plugin
module.exports = {"lock":"AccountLockedPage_lock__1DD4N","message":"AccountLockedPage_message__3zLkP"};